var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"promo--detail-banner"},[_c('picture',[_c('source',{attrs:{"srcset":_vm.banner.image,"type":"image/webp"}}),_c('source',{attrs:{"srcset":_vm.getFallbackImage(_vm.banner.image),"type":"image/jpeg"}}),_c('img',{attrs:{"src":_vm.getFallbackImage(_vm.banner.image),"alt":`${_vm.banner.title} - BeliRumah`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }